//swiperJS (carousel)

var swiper = new Swiper('.swiper-container-cover-1col-bg', {
  slidesPerView: 1,
  loop: true,
  speed: 800,
  pagination: {
  el: '.swiper-pagination',
  clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

var swiper = new Swiper('.swiper-container-block-3col-swiper', {
  slidesPerView: 5,
  spaceBetween: 30,
  loop: true,
  speed: 800,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },

  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 2,
      spaceBetween: 50
    },
    // when window width is >= 780px
    780: {
      slidesPerView: 3,
      spaceBetween: 50
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 50
    },
  },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

var swiper = new Swiper('.swiper-container-logo-swiper', {
  slidesPerView: 4,
  spaceBetween: 30,
  slidesPerColumn: 1,
  speed: 2000,
  freeMode: true,
  loop: true,
  loopFillGroupWithBlank: true,
  autoplay: {
  delay: 0,
  },
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 2,
      spaceBetween: 30,
      slidesPerColumn: 1,
      speed: 2000,
      freeMode: true,
      loop: true,
      loopFillGroupWithBlank: true,
      autoplay: {
      delay: 0,
      },
    },
    // when window width is >= 780px
    780: {
      slidesPerView: 4,
      spaceBetween: 30,
      slidesPerColumn: 1,
      speed: 2000,
      freeMode: true,
      loop: true,
      loopFillGroupWithBlank: true,
      autoplay: {
      delay: 0,
      },
    },
  },

});

var swiper = new Swiper('.swiper-container-testimonial-swiper', {
  slidesPerView: 1,
  loop: true,
  speed: 800,
  autoplay: {
  delay: 5000,
  },
  pagination: {
  el: '.swiper-pagination',
  clickable: true,
  },
});


var swiper_culture = new Swiper('.swiper-container-culture-swiper', {
  slidesPerView: 1,
  loop: true,
  speed: 800,

  // Navigation arrows
  navigation: {
    prevEl: '.next-button',
  },

  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },

  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  }

});
